import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DOMAIN = 'https://agencia-ppc.es';

// Map paths to their canonical versions
const getCanonicalUrl = (pathname) => {
  // Remove trailing slash
  const path = pathname.replace(/\/$/, '') || '/';
  
  // Root always canonicalizes to /es
  if (path === '/') {
    return `${DOMAIN}/es`;
  }
  
  // Map old URLs to canonical versions
  const canonicalMappings = {
    // French
    '/fr/servicios': '/fr/services',
    '/fr/creacion-web': '/fr/creation-web',
    '/fr/contacto': '/fr/contact',
    '/fr/privacidad': '/fr/confidentialite',
    // English
    '/en/servicios': '/en/services',
    '/en/creacion-web': '/en/web-creation',
    '/en/contacto': '/en/contact',
    '/en/privacidad': '/en/privacy',
  };
  
  const canonicalPath = canonicalMappings[path] || path;
  return `${DOMAIN}${canonicalPath}`;
};

const CanonicalTag = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip canonical for hidden/secured routes
    if (location.pathname.startsWith('/apagon') || location.pathname.startsWith('/dash')) {
      const existing = document.querySelector('link[rel="canonical"]');
      if (existing) existing.remove();
      return;
    }

    const canonicalUrl = getCanonicalUrl(location.pathname);
    
    // Find or create canonical link
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
    
    // Update Open Graph URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', canonicalUrl);
    }
    
    // Update Twitter URL
    let twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) {
      twitterUrl.setAttribute('content', canonicalUrl);
    }
  }, [location.pathname]);

  return null;
};

export default CanonicalTag;
